import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	purchaseOrders: [],
};

const purchaseOrdersSlice = createSlice({
	name: 'purchaseOrders',
	initialState: initialState,
	reducers: {
		setPurchaseOrders: (state, action) => action.payload,
		reset: (state, action) => initialState,
		setPurchaseOrder: (state, action) => {
			const purchaseOrder = action.payload;
			const index = state.data.findIndex(
				(e) => e._id === purchaseOrder._id
			);
			if (index !== -1) {
				state.data[index] = purchaseOrder;
			}
		},
	},
});

export const { setPurchaseOrders, reset, setPurchaseOrder } = purchaseOrdersSlice.actions;

export default purchaseOrdersSlice.reducer;
